import FirebaseConfig from '../helpers/FirebaseConfig.js';
import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'




Vue.use(Router)



const router = new Router({
  mode: process.env.IS_ELECTRON ? 'hash' : 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/:tenant',
      name: 'webMain',
      meta: { publicRouter: true, type: "web" },
      component: () => import(/* webpackChunkName: "about" */ '../components/Web/default-layout.vue'),
      children: [
        {
          path: 'booking',
          component: () => import(/* webpackChunkName: "about" */ '../components/Web/BookingLayout.vue'),
          children: [
            {
              path: '',
              props: { isWeb: true },
              name: 'web_reservas_golf',
              component: () => import(/* webpackChunkName: "about" */ '../components/Web/booking.vue'),
            },
            {
              path: 'top-tracer',
              props: { isWeb: true },
              name: 'web_reservas_toptracer',
              component: () => import('../components/Web/reservaTopTracerWeb.vue')
            }
          ]
        },
        {
          path: 'teesheet',
          component: () => import(/* webpackChunkName: "about" */ '../components/Web/BookingLayout.vue'),
          children: [
            {
              path: '',
              props: { isWeb: true },
              name: 'web_teesheet',
              component: () => import(/* webpackChunkName: "about" */ '../components/Web/TeeSheet.vue'),
            },
          ]
        },
        {
          path: 'bookingApp',
          component: () => import(/* webpackChunkName: "about" */ '../components/Web/BookingLayout.vue'),
          children: [
            {
              path: ':idCliente/:nombre',
              props: { isWeb: true },
              name: 'web_reservas_golf',
              component: () => import(/* webpackChunkName: "about" */ '../components/Web/bookingApp.vue'),
            },
          ]
        },
        {
          path: 'affiliates/:afiliate',
          name: 'web_affiliate',
          component: () => import(/* webpackChunkName: "about" */ '../components/Web/EmptyLayout.vue'),
          children: [
            {
              path: 'golf/booking/:typePaid/:idTarifario?/:idSubCategoria?/:nombre?/:mail?',
              name: 'web_affiliate_golf',
              props: { isWeb: true },
              component: () => import(/* webpackChunkName: "about" */ '../components/affiliates/AffiliatesBooking.vue')
            }
          ]
        },
      ]
    },
    {
      path: '/usa/:tenant',
      name: 'usaWebMain',
      meta: { publicRouter: true, type: "web" },
      component: () => import(/* webpackChunkName: "about" */ '../components/Web/default-layout.vue'),
      children: [
        {
          path: 'booking/:nombre/:mail/:hotel',
          props: { isWeb: true },
          name: 'web_reservas_usa',
          component: () => import(/* webpackChunkName: "about" */ '../components/UsaTransfers/reservaUsa.vue')
        },
      ]
    },
    {
      path: "/notFound",
      name: 'notFound',
      meta: { publicRouter: true, type: "web" },
      component: () => import('../components/MainComponents/notFound.vue')
    }

  ]
})

router.beforeEach(async (to, from, next) => {
  if (to.name == 'web_affiliate') {
    next(to.path + '/golf/booking/GUESTPAID');
  }
  if (!to.matched.length) {
    next({ name: 'notFound' })
  }
  if (to.name == 'notFound') {
    next()
  }
  if (to.name == 'web_reservas_toptracer') {
    location.href = "https://bookings.pargolfsolutions.com/booking/-NxOuj7eaLXL3Jd1B_WP"
  }
  try {
    let firebaseConf = new FirebaseConfig();
    firebaseConf.setTenantInLocal(to.params.tenant)
    if (to.params.tenant) {
      let existApp = await firebaseConf.getUrlDatabaseByTenant(to.params.tenant)
      if (to.name != 'notFound' && !existApp.ok) {
        next({ name: 'notFound' })
      }
      if (existApp.ok) {
        firebaseConf.setTenantInLocal(to.params.tenant)
      }
    }

    await store.dispatch('FirebaseApp/initFirebaseApp', null, { root: true })
  } catch (e) {
    //next({ name: 'notFound' })
  }
  document.title = "ParGolfSolution"



  next();
})

export default router;
